import { toast } from "react-toastify";
import { requestBackendReportExport } from "./backendReportExport";

export const SEARCH_TERM_REPORT_TYPE = "SEARCH_TERM";

export const SEARCH_TERM_COLUMN_ID_TO_API_KEY = {
  search_term: "search_term",
  text: "text",
  targeting: "targeting",
  match_type: "match_type",
  portfolio: "portfolio_name",
  mt_campaign_name: "campaign_name",
  mt_adgroup_name: "ad_group_name",
  spends: "spends",
  orders: "orders",
  sale_value: "sale_value",
  roas: "roas",
};

export function getSearchTermVisibleColumnKeys(dataHeads = []) {
  return dataHeads
    .map((head) => SEARCH_TERM_COLUMN_ID_TO_API_KEY[head.id] ?? head.id)
    .filter(Boolean);
}

export function buildSearchTermExportQueryBody({
  startDate,
  endDate,
  orderBy,
  sortingOrder,
  masterRow = false,
  filtering = [],
  keywordHarvesting = false,
  productHarvesting = false,
}) {
  return {
    master_row: masterRow,
    order_by: orderBy,
    sorting_order: sortingOrder,
    start_date: startDate,
    end_date: endDate,
    filtering,
    keyword_harvesting: keywordHarvesting,
    product_harvesting: productHarvesting,
  };
}

export async function exportSearchTermReport({
  clientId,
  userPlatform = "amazon",
  triggeredBy,
  totalCount,
  queryBody,
  visibleColumnKeys,
  setIsExporting = () => {},
  onExportSuccess = () => {},
}) {
  try {
    setIsExporting(true);

    await requestBackendReportExport({
      clientId,
      userPlatform,
      reportType: SEARCH_TERM_REPORT_TYPE,
      totalCount,
      triggeredBy,
      queryBody,
      frontendConfig: {
        columns: visibleColumnKeys,
      },
    });

    onExportSuccess();
  } catch (error) {
    console.error(error);
    toast.error(
      error?.response?.data?.message ?? "Failed to submit export request."
    );
  } finally {
    setIsExporting(false);
  }
}
